import { InjectionToken } from '@angular/core';
import { CheckoutService } from '@models';

export const CHECKOUT_SERVICE = new InjectionToken<CheckoutService>(
  'CheckoutService'
);
